import React from 'react';
import {

    RichCell,


    Button, SplitLayout, SplitCol, Div, SimpleCell, Switch, Alert,
} from '@vkontakte/vkui';
import {
    AdaptivityContext, EMPTY_INN, inducement, setQuizStep,
} from "../../assets/constants";


import {
    Icon20AddCircleFillGreen, Icon20DeleteOutline,
    Icon20EditCircleFillBlue, Icon20RemoveCircleOutline,
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import KlientsApi from "../../api/references/klients";
import BaseList from "../../components/BaseList";


class KlientsList extends BaseList {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            currentItemId: null,
            showAll: false,
        }
    }

    // Дополнительные поля для сохранения состояния
    getAdditionalStateToSave() {
        return {
            showAll: this.state.showAll
        };
    }

    getItems = (mainSearch = '', append = false, page = 1) => {
        clearInterval(this.searchInterval);

        console.log(this.state)

        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch
        }


        KlientsApi.getList(
            {
                no_empty_inn: 1,
                no_empty_parents: !this.state.showAll ? 1 : 0,
                search: mainSearch,
                show_all: 1,

                page,
                epp: AdaptivityContext.isMobile ? 10 : 20
            }
        ).then(response => {

            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })


    }

    createItem = () => {
        window.postMessage({
            type: 'setCurrentKlient',
            value: {id: -1}
        })
    }
    getObjectLink = (item) => {
        if (!item || item.id == null || item.id <= 0) {
            return null;
        }
        return {type: 'klient', id: item.id};
    }

    getItem = (item) => {
        this.setLastOpenedItem(item.id);
        KlientsApi.getOne(item.id).then(response => {
            const {data} = response

            if (data.id) {
                window.postMessage({type: 'setCurrentKlient', value: data})
            }
        })
    }
    deleteItem = (item, index) => {

        if (item.sale_points_cnt > 0) {
            window.postMessage({
                type: 'error',
                text: 'У клиента есть активные торговые точки, невозможно удалить клиента'
            })

            return
        }


        const alert = <Alert
            onClose={() => this.setState({currentPopout: null})}
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Да',
                    action: () => {
                        KlientsApi.deleteKlient(item.id).then(response => {
                            const {data} = response
                            if (data.success) {
                                const {items} = this.state

                                items.splice(index, 1)

                                this.setState({items, currentPopout: null})
                            }
                        })
                    },

                },
                {
                    title: 'Нет',
                    action: () => {
                        this.setState({currentPopout: null})
                    },
                },
            ]}

            header="Удаление клиента"
            text={`Удалить клиента ${item.title}?`}
        />

        this.setState({currentPopout: alert})
    }
    setShowAll = (e) => {

        this.setState({loading: true, showAll: e.target.checked, page: 1, items: []})

        setTimeout(() =>
            this.getItems(undefined, false, 1), 700)
    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>
                    <Div>
                        <Button mode="outline"
                                onClick={() => this.createItem()}><Icon20AddCircleFillGreen/></Button>

                    </Div>
                </SplitCol>

                <SplitCol>
                    <Div>
                                <span className="all-docs"
                                      id="cnt_items">Всего элементов: {this.state.cnt_items}</span>


                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }
    renderRow = (item, index) => {

        let backgroundColor = 'inherit'


        if(item.INN == EMPTY_INN){
            backgroundColor = 'rgba(255,75,75,0.57)'
        }


        return <RichCell subhead={item.INN} multiline
                         style={this.getRowStyle(item, { backgroundColor })}
                         caption={item.INN == EMPTY_INN ?<span style={{color: 'red'}}>Не пройдена модерация, не известный клиент</span>:''}
                         afterCaption={<div style={{display: "flex", flexDirection: "column"}}>

                             <Button mode="outline" size="m"
                                     onClick={() => this.getItem(item)}><Icon20EditCircleFillBlue/></Button>
                             <Button mode="outline" size="m"
                                     onClick={() => this.deleteItem(item, index)}><Icon20DeleteOutline /></Button>
                         </div>
                         }
                         bottom={
                             <span>{item.sale_points_cnt > 0 ? item.sale_points_cnt : 'Нет'} {inducement(item.sale_points_cnt, 'торговая точка', 'торговые точки', 'торговых точек')}</span>}
        >

            {item.title}
        </RichCell>
    }

}

export default KlientsList